// Generated by scripts/generate-public-surface.ts. Do not edit.
export { default as cpf } from "./cpf";
